import {BrowserRouter, Link, Route, Routes} from 'react-router-dom';
import './App.css';

import Admin from './Admin.jsx';
import Home from './Home.js';

import Blog from './Blog.jsx';
import Contacts from './Contacts.js';
import Events from './Events.js';
import Quicklinks from './Links.js';
import RequireAuth from './RequireAuth.jsx';
import SignIn from './SignIn.jsx';

import Advent from './AdventOfMaps.js';
import Beginner from './Beginner.js';
import BlogEntry from './BlogEntry.jsx';
import './firebase.js';
import facebook from './icons/facebook.svg';
import discord from './icons/ic_baseline-discord.svg';
import instagram from './icons/mdi_instagram.svg';
import linkdin from './icons/mdi_linkedin.svg';
import logo from './logo.svg';
import MCPC from './MCPC.js';
import {FooterLink} from './obj.js';
import SPPC from './SPPC.js';
import Training from './Training.js';
import Workshops from './Workshop.js';

function toggleMenu() {
	var menu = document.getElementById('navbar');
	if (menu.style.opacity === '0') {
		//menu.style.width = "120px";

		menu.style.opacity = 1;
	} else {
		menu.style.opacity = 0;
		// menu.style.width = 0;
	}
}

function Navbar() {
	return (
		<>
			<header className="header">
				<Link to="/" className="logoImg">
					<img src={logo} alt="MAPS logo"></img>
				</Link>
				<nav id="navbar">
					<Link to="/" className="menuButton">
						home
					</Link>
					<Link to="/blog" className="menuButton">
						blog
					</Link>
					<Link to="/events" className="menuButton">
						events
					</Link>
					<Link to="/contacts" className="menuButton">
						contacts
					</Link>
					<Link to="/links" className="menuButton">
						quicklinks
					</Link>
					<Link
						to="/discord"
						target="_blank"
						className="accentButton menuButton"
					>
						join us
					</Link>
				</nav>
				<button className="menuButton" id="menuToggle" onClick={toggleMenu}>
					menu
				</button>
			</header>
			<div className="headerspacer" />
		</>
	);
}

function Footer() {
	return (
		<footer>
			<FooterLink src={discord} to="/discord"></FooterLink>
			<FooterLink src={instagram} to="/instagram"></FooterLink>
			<FooterLink src={facebook} to="/facebook"></FooterLink>
			<FooterLink src={linkdin} to="/linkedin"></FooterLink>
		</footer>
	);
}
function App() {
	return (
		<BrowserRouter>
			<Navbar />
			<Routes>
				<Route index element={<Home />}></Route>
				<Route path="/blog">
					<Route index element={<Blog />}></Route>
					<Route path=":blogId" element={<BlogEntry />}></Route>
				</Route>

				<Route path="/events">
					<Route index element={<Events />}></Route>
					<Route path="workshops" element={<Workshops />}></Route>
					<Route path="training" element={<Training />}></Route>
					<Route path="beginner" element={<Beginner />}></Route>
					<Route path="mcpc" element={<MCPC />} />
					<Route path="advent" element={<Advent />} />
					<Route path="sppc" element={<SPPC />} />
				</Route>

				<Route path="/contacts" element={<Contacts />}></Route>
				<Route path="/links" element={<Quicklinks></Quicklinks>}></Route>
				<Route
					path="/admin"
					element={
						<RequireAuth>
							<Admin />
						</RequireAuth>
					}
				/>
				<Route path="/signin" element={<SignIn />} />

				{/* {links.map(ent => (
          <Route path = {'/' + ent.name} element = {<Redirect address = {ent.address}/>}>
          </Route>
        ))} */}
			</Routes>
			<Footer></Footer>
		</BrowserRouter>
	);
}

// function Page(){
//   return (

// )
// }

export default App;
